import axios from "axios";
import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus,getHeaders } from "../../../../Services/SharedSevices/SharedServices";
const baseURL = process.env.REACT_APP_BASE_URL;
export async function getGroupManage(params) {
    try {
      const response = await axiosInstance.post(`${baseURL}/Message/Group/List`, params, {
        headers: await getHeaders(),
        body: JSON.stringify(params)
      });
      checkStatus(response);
      return response.data;
    }catch(error){
      return Promise.reject(error);
    }    
  }

  export const getOrganizationAppLinks = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/OrgAppLinks/Get`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

  export const addOrganizationAppLinks = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/OrgAppLinks`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete Org App Links
export const deleteOrganizationAppLinks = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/OrgAppLinks/Delete`,
      {
        headers: await getHeaders(),
        data: params                 // sending body via config.data
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get Org Locations Settings
  export const getOrganizationLocations = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/LocationType`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add & Edit Locations Settings
  export const addOrganizationLocations = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/LocationType/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };



// Delete Locations Settings
export const deleteOrganizationLocations = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/LocationType/Delete`,
      {
        headers: await getHeaders(),
        data: params                 
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

// Get Organisation Policy Category..
  export const getOrganizationPolicyCategory = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Policy/OrgPolicyCategory/GetAllOrgPolicyCategory`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }

 
// Add/Edit Organisation Policy Category..
export const addOrganizationPolicyCategory = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Policy/OrgPolicyCategoryAddUpdateOrgPolicyCategory`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete Organisation Policy Category..
export const deleteOrganizationPolicyCategory = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Policy/OrgPolicyCategory/DeleteOrgPolicyCategory`,
      {
        headers: await getHeaders(),
        data: params
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

 
// Get Org Department types..
  export const getOrganizationDepartments = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/Department`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// Add & Edit Department types..
export const addOrganizationDepartments = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/Department/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// Delete Org Department types...
export const deleteOrganizationDepartments = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/Department/Delete`,
      {
        headers: await getHeaders(),
        data: params
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};


// Get Org Designation Setting...
  export const getOrganizationDesignation = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/Designation`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }



// Add & Edit Org Designation Setting...
export const addOrganizationDesignation = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/Designation/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };



// Delete Org Designation Setting...
export const deleteOrganizationDesignation = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/Designation/Delete`,
      {
        headers: await getHeaders(),
        data: params 
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};
  
// Get Organisation Branches..
  export const getOrganizationBranch = async (params) => {
    try {
        const response = await axiosInstance.get(`${baseURL}/Org/Branches`, {
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
        checkStatus(response);
        return response.data;
      } catch (error) {
        return Promise.reject(error);
      }
  }


// add & edit Organisation Branches..
export const addOrganizationBranch = async (params) => {
    try {
      const response = await axiosInstance.post(
        `${baseURL}/Org/Branches/Add`,params,{
          headers: await getHeaders(),
          body: JSON.stringify(params)
        });
      
      checkStatus(response);
      return response.data;
    } catch (error) {
      return Promise.reject(error);
    }
  };


// delete Organisation Branches..
export const deleteOrganizationBranch = async (params) => {
  try {
    const response = await axiosInstance.delete(
      `${baseURL}/Org/Branches/Delete`,
      {
        headers: await getHeaders(),
        data: params 
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const GetOrgSystemAlertList = async(params) => {
 try {
    const response = await axiosInstance.get(`${baseURL}/Master/OrgSystemAlerts?Name=${params.Name}`,
      {
        headers: await getHeaders(),
        data: JSON.stringify(params)  
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const updateOrgAddressDetails = async(params) => {
  try {
    const response = await axiosInstance.post(
      `${baseURL}/Org/Update/Address`, params,
      {
        headers: await getHeaders(),
        data: JSON.stringify(params)  
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}
